import { createFileRoute } from '@tanstack/react-router';
import { usePlanPermissionOptions } from 'src/lib/queries/adaptive-planner/usePlanPermission';
import { FullSizeSpinner } from '@/components/ui/FullSizeSpinner';
import { getPlanQueryOptions } from '@/lib/queries/adaptive-planner/useGetPlanQuery';
import { getScenarioQueryOptions } from '@/lib/queries/adaptive-planner/useGetScenarioQuery';
import { getTimelineItemsDataSetQueryOptions } from '@/lib/queries/adaptive-planner/useGetTimelineItemsDataSetQuery';
import type { LoaderData } from '@/lib/types/common';

export const Route = createFileRoute(
  '/(app)/org/$org/adaptive-planner/plan/$planId/backlog/scenario/$scenarioId',
)({
  loader: async ({
    context: { queryClient },
    params: { scenarioId, planId },
  }): Promise<LoaderData> => {
    const planNum = Number(planId);
    const scenarioNum = Number(scenarioId);

    const { scenario } = await queryClient.ensureQueryData(
      getScenarioQueryOptions({ planId: planNum, scenarioId: scenarioNum }),
    );
    await queryClient.ensureQueryData(getPlanQueryOptions({ planId: planNum }));
    await queryClient.ensureQueryData(
      getTimelineItemsDataSetQueryOptions({
        planId: planNum,
        scenarioId: scenarioNum,
      }),
    );
    await queryClient.ensureQueryData(usePlanPermissionOptions({ planId: planNum }));
    const crumb = scenario.name;
    return {
      crumb,
    };
  },
  pendingComponent: FullSizeSpinner,
});
